module.exports = __webpack_public_path__ + "static/media/picketPluses2.7fb6e065.jpg";